import type { Operation } from 'fast-json-patch'

const INCIDENT_DATE_TIME_PATH = '/incidentDateTime'

const toMillis = (value: Date | string | undefined): number | undefined => {
  if (value === undefined) return undefined
  const ms = new Date(value).getTime()
  return Number.isNaN(ms) ? undefined : ms
}

/**
 * fast-json-patch mirrors the form as JSON, so its incidentDateTime is an ISO string while the
 * form holds a live Date. It therefore always emits `replace /incidentDateTime`, even when the
 * staff member never touched the timestamp. Drop that op when the instant is unchanged.
 */
export const dropUnchangedIncidentDateTime = (
  ops: Operation[],
  original: Date | string | undefined,
  current: Date | string | undefined
): Operation[] => {
  const originalMs = toMillis(original)
  if (originalMs === undefined || originalMs !== toMillis(current)) return ops
  return ops.filter((op) => op.path !== INCIDENT_DATE_TIME_PATH)
}
